import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import config from 'utils/config';
import queryparse from 'tricks/string/queryparse';
import createLocation from 'utils/createLocation';
import { typeFilterOptions } from 'types/content';
import SelectField from 'components/Fields/SelectField';
import { jsx as _jsx } from "react/jsx-runtime";
function ContentTypeFilter() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var navigate = useNavigate();
  var location = useLocation();
  var queryParams = queryparse(location.search);
  var _queryParams$type = queryParams.type,
    selectedType = _queryParams$type === void 0 ? 'all' : _queryParams$type;
  var baseOptions = config.eventAssets ? typeFilterOptions : typeFilterOptions.filter(function (_ref) {
    var value = _ref.value;
    return value !== 'events';
  });
  var options = baseOptions.map(function (_ref2) {
    var value = _ref2.value,
      labelTranslationKey = _ref2.labelTranslationKey;
    return {
      value: value,
      title: t(labelTranslationKey)
    };
  });
  function handleChange(_id, value) {
    navigate(createLocation(location.pathname, _objectSpread(_objectSpread({}, queryParams), {}, {
      type: value,
      page: undefined
    })), {
      replace: true
    });
  }
  return /*#__PURE__*/_jsx(SelectField, {
    id: "content-type-filter",
    title: t('property_type_colon'),
    selectedValue: selectedType,
    onChange: handleChange,
    options: options,
    variant: "transparent",
    horizontal: true,
    horizontalLabelWidth: "auto",
    horizontalBreakpoint: "xxxs",
    bold: false
  });
}
export default ContentTypeFilter;